import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dropdown,
  OverlayTrigger,
  Toast,
  ToastContainer,
  Tooltip,
} from "react-bootstrap";
import AuthServiceV3 from "../../../services/Operation.serviceV3";
import { useNavigate } from "react-router-dom";
//icon
import { LuBellRing } from "react-icons/lu";
import { ImCross } from "react-icons/im";
import { IoTrashBinSharp } from "react-icons/io5";
import Static_modal from "./Static_modal";
export default function Notification(test) {
  const [notification_data, setNotifications_data] = useState([]);
  const [noti_bool, setNoti_Bool] = useState(false);
  const [removingItemId, setRemovingItemId] = useState(null);
  const  Navigate = useNavigate();
  const [modalToggle, setModalToggle] = useState({
      modalSuccess: false,
      modalDenied: false,
      modalErr: false,
      modalwait: false,
    });
    const [textBody, setTextBody] = useState();
  const arrTest = [
    { id: 1, name: "Notification 1", description: "Description 1" },
    { id: 2, name: "Notification 2", description: "Description 2" },
    { id: 3, name: "Notification 3", description: "Description 3" },
    { id: 4, name: "Notification 4", description: "Description 4" },
    { id: 5, name: "Notification 5", description: "Description 5" },
    { id: 6, name: "Notification 6", description: "Description 6" },
  ];
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  function calculateTimeDifference(created_at) {
    const createdAtDate = new Date(created_at);
    const currentTime = new Date();

    // Calculate the time difference in milliseconds
    const timeDifference = currentTime - createdAtDate;

    // Convert milliseconds to seconds
    const seconds = Math.floor(timeDifference / 1000);

    // Calculate minutes, hours, days, and years
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const years = Math.floor(days / 365);

    if (years > 0) {
      return years + " year(s) ago";
    } else if (days > 0) {
      return days + " day(s) ago";
    } else if (hours > 0) {
      return hours + " hour(s) ago";
    } else if (minutes > 0) {
      return minutes + " minute(s) ago";
    } else {
      return seconds + " second(s) ago";
    }
  }

  const UpdateNotification_Server = (id) => {
    console.log(id);
    setRemovingItemId(id);
    setTimeout(() => {
      const updatedNotifications = notification_data.filter(
        (notification) => notification.noti_id !== id
      );
      setNotifications_data(updatedNotifications);
      setRemovingItemId(null);
    }, 300);
    const data = AuthServiceV3.UpdateNotificationOperation("n", id).catch((error) => {
      setTextBody(error);
      setModalToggle({ ...modalToggle, modalErr: true })})
  };
  const UpdateNotification_Server_All = () => {
    let all = "y";
    setNotifications_data([]);
    const check = sessionStorage.getItem("operator_id")
    console.log(check)
    if(check !== null){
      
     const data = AuthServiceV3.UpdateNotificationOperation(all).catch((error) => {
      setTextBody(error);
      setModalToggle({ ...modalToggle, modalErr: true });
    })
    }else{
      console.log("pass")
    }
    
  };

  ////fetching_data
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await AuthServiceV3.NotificationOperation();
        //console.log(response);
        if (response !== undefined) {
          //console.log(response);
          if(response.status===200){
            if (response.data !== null && response.data.length !== 0) {
              setNotifications_data(response.data);
            } else {
              setNotifications_data([]);
            }
          }else{
            setNotifications_data([]);
          }
          
        } else {
          alert("ไม่สามารถเชื่อมต่อได้ กรุณา Login ใหม่");
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
  }, []);
  ///action for other click close dropdown
  const dropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setNoti_Bool(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div>
      {noti_bool === true ? (
        <>
          <div className="card-noti-box" ref={dropdownRef}>
            <div className="card-noti-header">
              <h5 style={{ marginLeft: "15px" }}>แจ้งเตือนแผนการบิน</h5>
              <OverlayTrigger
                key={"top"}
                placement={"top"}
                overlay={<Tooltip id={`tooltip-${"top"}`}>ลบทั้งหมด</Tooltip>}
              >
                <a  onClick={() => UpdateNotification_Server_All()}>
                  <IoTrashBinSharp
                    className="bin-icon"
                    style={{
                      marginRight: "15px",
                    }}
                  />
                </a>
              </OverlayTrigger>
            </div>

            <div className="card-noti-content">
              {notification_data.length === 0 ? null : (
                <>
                  {notification_data.map((item, index) => {
                    const isRemoving = removingItemId === item.noti_id;
                    return (
                      <>
                        <Toast
                          style={{ borderRadius: "10px" }}
                          key={index}
                          className={`notification-item ${
                            isRemoving ? "removing" : ""
                          }`}
                        >
                          <Toast.Header
                            closeButton={false}
                            style={{
                              backgroundColor: "#0077b6",
                              color: "white",
                            }}
                          >
                            <strong className="me-auto">{`Notification : ${item.noti_id}`}</strong>
                            <small style={{ color: "white" }}>
                              {calculateTimeDifference(item.created_at)}
                            </small>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() =>
                                UpdateNotification_Server(item.noti_id)
                              }
                              aria-label="Close"
                            ></button>
                          </Toast.Header>
                          <Toast.Body
                            style={{
                              borderRadius: "0px 0px 10px 10px",
                              backgroundColor: "rgba(126, 220, 252, 0.8)",
                              cursor:"pointer"
                            }}
                            onClick={() => {
                              Navigate("/user/drone/statusflightdrone");
                            }}
                          >
                            {`รหัส : ${item.operation_code}`}
                            <br />
                            {`การแจ้งเตือน : ${item.message}`}
                          </Toast.Body>
                        </Toast>
                      </>
                    );
                  })}
                </>
              )}
            </div>
          </div>
          <div
            className="noti-bell-box"
            onClick={() => {
              setNoti_Bool(!noti_bool);
            }}
          >
            <ImCross className="noti-bell" />
          </div>
        </>
      ) : (
        <>
          <div
            className="noti-bell-box"
            onClick={() => {
              setNoti_Bool(!noti_bool);
            }}
          >
            {notification_data.length !== 0 ? (
              <span className="noti-bell-span">{notification_data.length}</span>
            ) : null}
            <LuBellRing className="noti-bell" />
          </div>
        </>
      )}
      <Static_modal
          modalwaiting={modalToggle.modalwait}
          modalErr={modalToggle.modalErr}
          modalSuccess={modalToggle.modalSuccess}
          modalDenied={modalToggle.modalDenied}
          textBody={textBody}
          getHandle={handleClose_Modal}
        />
    </div>
  );
}
